import { TextResponse } from "pages/assistant/components/chat/components/responses/TextResponse";
import { useEffect } from "react";
import { CustomDataArtifactRecord } from "types/AssistantTypes";

type Props = {
  data: CustomDataArtifactRecord;
  onLoaded?: () => void;
};

export const FinecoProductComparisonArtifact = ({ data, onLoaded }: Props) => {
  useEffect(() => onLoaded?.(), []);

  const text = data?.report;

  if (!text) {
    return null;
  }
  return <TextResponse message={text} />;
};
